import VideoCard from './VideoCard';
import { jsx as _jsx } from "react/jsx-runtime";
const MovieAttachmentCard = ({
  fileMetadata
}) => {
  return /*#__PURE__*/_jsx(VideoCard, {
    fileMetadata: fileMetadata,
    thumbnailMetadata: fileMetadata === null || fileMetadata === void 0 ? void 0 : fileMetadata.thumbnailMetadata
  });
};
MovieAttachmentCard.displayName = 'MovieAttachmentCard';
export default MovieAttachmentCard;